import { queryConstants } from '../_constants';
import { queryService } from '../_services';

export const queryActions = {
    getAll,
		updateQuery,
		addQuery,
		deleteQuery,
		activateQuery,
		deactivateQuery,
		getActive,
		getInactive
};

export function queryHasErrored(bool) {
    return {
        type: queryConstants.GET_QUERY_FAILURE,
        hasErrored: bool
    };
}
export function queryIsLoading(bool) {
    return {
        type: queryConstants.GET_QUERY_REQUEST,
        isLoading: bool
    };
}
export function queryFetchDataSuccess(items) {
    return {
        type: queryConstants.GET_QUERY_SUCCESS,
        items
    };
}

function getAll(token, sport) {
    return dispatch => {
				console.log("Get All Queries");
        dispatch(request());

        queryService.getAll(token, sport)
            .then(
                queries => dispatch(success(queries)),
                error => dispatch(failure(error))
            );
    }

    function request() { return { type: queryConstants.GET_QUERY_REQUEST } }
    function success(queries) { return { type: queryConstants.GET_QUERY_SUCCESS, queries } }
    function failure(error) { return { type: queryConstants.GET_QUERY_FAILURE, error } }
}

function getActive(token, sport) {
    return dispatch => {
        dispatch(request());

        queryService.getActive(token, sport)
            .then(
                queries => dispatch(success(queries)),
                error => dispatch(failure(error))
            );
    }

    function request() { return { type: queryConstants.GET_ACTIVE_QUERY_REQUEST } }
    function success(queries) { return { type: queryConstants.GET_ACTIVE_QUERY_SUCCESS, queries } }
    function failure(error) { return { type: queryConstants.GET_ACTIVE_QUERY_FAILURE, error } }
}

function getInactive(token, sport) {
    return dispatch => {
        dispatch(request());

        queryService.getInactive(token, sport)
            .then(
                queries => dispatch(success(queries)),
                error => dispatch(failure(error))
            );
    }

    function request() { return { type: queryConstants.GET_INACTIVE_QUERY_REQUEST } }
    function success(queries) { return { type: queryConstants.GET_INACTIVE_QUERY_SUCCESS, queries } }
    function failure(error) { return { type: queryConstants.GET_INACTIVE_QUERY_FAILURE, error } }
}

function activateQuery(token, sport, query){
	return dispatch => {
		dispatch(request());
		queryService.activateQuery(token, sport, query)
			.then(
					(sport, query) => dispatch(success(sport, query)),
					error => dispatch(failure(error))
			);
	}

  function request() { return { type: queryConstants.PUT_QUERY_REQUEST } }
  function success(sport, query) { return { type: queryConstants.PUT_QUERY_SUCCESS, sport, query } }
  function failure(error) { return { type: queryConstants.PUT_QUERY_FAILURE, error } }
}

function deactivateQuery(token, sport, query){
	return dispatch => {
		dispatch(request());
		queryService.deactivateQuery(token, sport, query)
			.then(
					(sport, query) => dispatch(success(sport, query)),
					error => dispatch(failure(error))
			);
	}

  function request() { return { type: queryConstants.PUT_QUERY_REQUEST } }
  function success(sport, query) { return { type: queryConstants.PUT_QUERY_SUCCESS, sport, query } }
  function failure(error) { return { type: queryConstants.PUT_QUERY_FAILURE, error } }
}

function updateQuery(token, sport, oldQuery, newQuery){
	return dispatch => {
		dispatch(request());
		queryService.updateQuery(token, sport, oldQuery, newQuery)
			.then(
					(sport, query) => dispatch(success(sport, query)),
					error => dispatch(failure(error))
			);
	}

  function request() { return { type: queryConstants.PUT_QUERY_REQUEST } }
  function success(sport, query) { return { type: queryConstants.PUT_QUERY_SUCCESS, sport, query } }
  function failure(error) { return { type: queryConstants.PUT_QUERY_FAILURE, error } }
}

function addQuery(token, sport, query){
	return dispatch => {
		dispatch(request());
		queryService.addQuery(token, sport, query)
			.then(
					(sport, query) => dispatch(success(sport, query)),
					error => dispatch(failure(error))
			);
	}

  function request() { return { type: queryConstants.POST_QUERY_REQUEST } }
  function success(sport, query) { return { type: queryConstants.POST_QUERY_SUCCESS, sport, query } }
  function failure(error) { return { type: queryConstants.POST_QUERY_FAILURE, error } }
}


function deleteQuery(token, sport, query){
	return dispatch => {
		dispatch(request());
		queryService.deleteQuery(token, sport, query)
			.then(
					(sport, query) => dispatch(success(sport, query)),
					error => dispatch(failure(error))
			);
	}

  function request() { return { type: queryConstants.DELETE_QUERY_REQUEST } }
  function success(sport, query) { return { type: queryConstants.DELETE_QUERY_SUCCESS, sport, query } }
  function failure(error) { return { type: queryConstants.DELETE_QUERY_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/queries.js